import React from 'react';

interface ButtonProps {
  type?: 'primary' | 'secondary' | 'danger';
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({ 
  type = 'primary', 
  onClick, 
  children, 
  className = '',
  disabled = false
}) => {
  const baseClasses = 'px-4 py-2 rounded font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  let typeClasses = '';
  
  switch (type) {
    case 'primary':
      typeClasses = disabled 
        ? 'bg-blue-300 text-white cursor-not-allowed'
        : 'bg-blue-500 hover:bg-blue-600 text-white focus:ring-blue-500';
      break;
    case 'secondary':
      typeClasses = disabled
        ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
        : 'bg-gray-200 hover:bg-gray-300 text-gray-700 focus:ring-gray-500';
      break;
    case 'danger':
      typeClasses = disabled
        ? 'bg-red-300 text-white cursor-not-allowed'
        : 'bg-red-500 hover:bg-red-600 text-white focus:ring-red-500';
      break;
  }
  
  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      className={`${baseClasses} ${typeClasses} ${className}`}
      disabled={disabled}
      aria-disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button; 